"use strict";
exports.__esModule = true;
/**
 * @module
 */
/**
 * @author rouven
 */
var actions_1 = require("../actions");
/**
 * Middleware that changes the href of the current window/tab if an 401 unauthorized Response is received.

 * @category middleware
 * @param target {string} the url to redirect to
 * @param store {object} the app store
 * @param next {function} the next middleware
 * @param action {objecŧ} the action to be dispatched
 * @return {function} next applied to action
 */
var ajaxErrorMiddleware = function (target) { return function (store) { return function (next) { return function (action) {
    if (action.type === actions_1.types.LOAD_DATA_FAILURE && action.error.status === 401) {
        location.href = target;
    }
    return next(action);
}; }; }; };
exports["default"] = ajaxErrorMiddleware;
